export const MAX_INPUT_DATE="9999-12-31"
export const FIRST_LEVEL_BULLET = ` • `
export const SECOND_LEVEL_BULLET = ` ◦ `
export const NUMBERING = `[\\dA-Za-z]+\\.|[\\dA-Za-z]+\\)`
export const VERTICAL_LINE_CHAR = '|'
export const NEW_LINE_CHAR = '\n'
export const BULLETS_ARR = [`•`, `◦`, `○`, `‣`, `▹`, `◼`, `◻`, ``, ``,`➢`,``, `♦`, `❖`, `■`]